import { render } from "./Logaritma.vue?vue&type=template&id=221c580c"
import script from "./Logaritma.vue?vue&type=script&lang=js"
export * from "./Logaritma.vue?vue&type=script&lang=js"

import "./Logaritma.vue?vue&type=style&index=0&id=221c580c&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__